module.exports = __webpack_public_path__ + "images/referenzen/werbespot/dominos_club_tvc.jpg";